import { makeStyles } from '@material-ui/core';

export const useFilledInputStyles = makeStyles({
    filledInput: {
      '&.Mui-focused': {
        backgroundColor: '#ebf2ff !important'
      }
    }
});